/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid } from "../../clients/classPlanningGradeAndFrequenceConfigurationController/postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";

export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey =
  () =>
    [
      {
        url: "/api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId",
      },
    ] as const;

export type PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey =
  ReturnType<
    typeof postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey
  >;

export function postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey();
  return mutationOptions<
    PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    {
      classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
      data?: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ classModuleId, data }) => {
      return postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid(
        classModuleId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Vincula as Aulas informadas ao Módulo (aditivo). Aula já vinculada a outro Módulo é realocada. **(Requer Authorization para autenticação)**
 * @summary Anexar Aulas ao Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId}
 */
export function usePostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
      >,
      {
        classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
        data?: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationKey();

  const baseOptions =
    postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
        | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
      >,
      {
        classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
        data?: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    {
      classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
      data?: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404
      | PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500
    >,
    {
      classModuleId: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams["classModuleId"];
      data?: PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest;
    },
    TContext
  >;
}
